import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { WithRouter } from 'shared/decorators/withRouter';

const styles = require('./error.css');

interface IState extends IStateBase {
}

interface IProps {
  message?: string;
}

@WithRouter()
export default class Error extends BaseComponent<IState, IProps> {

  render() {

    const message = this.props.message || 'Não encontramos a página que você está procurando.';

    return (
      <div className={styles.component}>
        <div className='container'>
          <section className={'content'}>
            <div className='eduzz' />
            <div className='eduzinho' />
            <div className='text'>
              <h1>Oopzz!</h1>
              <h2>{message}</h2>
              <div className='acao'>
                <a href='http://my.eduzz.com'>Página inicial</a>
                <a href='https://eduzz.zendesk.com/hc/pt-br'>Central de Ajuda</a>
              </div>
            </div>
          </section>
        </div>
      </div>);
  }

}


// WEBPACK FOOTER //
// ./src/components/Error/index.tsx